'use client';

import { type AbstractIntlMessages, NextIntlClientProvider } from 'next-intl';
import { type FC, type ReactNode, useMemo } from 'react';

import { ApolloProvider } from '@apollo/client';

import en from 'dayjs/locale/en';
import ru from 'dayjs/locale/ru';

import { useLocale } from '@/hooks/use-locale';
import { defaultTimezone, type Locale } from '@/i18n/routing';
import { useApolloClient } from '@/lib/apollo-client';
import dayjs from '@/utils/dayjs';

type AllProvidersProps = {
  locale: Locale;
  messages: AbstractIntlMessages;
  children?: ReactNode;
};

en.formats = ru.formats;

export const AllProviders: FC<AllProvidersProps> = (props) => {
  // Выглядит сомнительно, но пока лучшего способа как будто нет
  dayjs.locale(useLocale());

  const { locale, messages, children } = props;

  const apolloClient = useApolloClient();

  const timezone = useMemo(() => {
    try {
      return Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch (err) {
      return defaultTimezone;
    }
  }, []);

  return (
    <NextIntlClientProvider locale={locale} timeZone={timezone} messages={messages}>
      <ApolloProvider client={apolloClient}>{children}</ApolloProvider>
    </NextIntlClientProvider>
  );
};
